import React, {useEffect, useState} from 'react';
import {Button, Modal, Select} from "antd";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import CountryModal from "../LocationModal/CountryModal";
import RegionModal from "../LocationModal/RegionModal";
import DistrictModal from "../LocationModal/DistrictModal";
import ModalOfficeHierarchy from "./ModalOfficeHierarchy";

const DeleteModal = (props) => {

    const deleteItem = () => {
        axios.delete(API_PATH + "company/" + localStorage.getItem("id") + "/branch/"+ props?.selectId , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
             props?.getAllData()
                props?.setIsModal(false)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    return (
        <>
            <Modal title={props?.title}
                   open={props.isModal}
                   onCancel={() => props.setIsModal(false)}
                   footer={[
                       <Button key="submit" type="primary" onClick={() => deleteItem(props?.selectData)}>
                           Удалить
                       </Button>,
                       <Button key="submit" type="default" onClick={() => props.setIsModal(false)}>
                           Отменить
                       </Button>
                   ]}
            >
                <div className="cam-add-modal">
                    <h4 className="mt-0 text-white">Вы уверены, что хотите удалить?</h4>
                </div>
            </Modal>
        </>
    );
};

export default DeleteModal;